class SignupDelegate {
    setFirstName(firstName) {
        this.setState({ firstName });
    }

    setLastName(lastName) {
        this.setState({ lastName });
    }

    setEmail(email) {
        this.setState({ email });
    }

    setCompanyName(companyName) {
        this.setState({ companyName });
    }

    setPhoneNumber(phoneNumber) {
        this.setState({ phoneNumber });
    }

    setPassword(password) {
        this.setState({ password });
    }
}

export default SignupDelegate;

